import React from "react";

import {Button, DatePicker, notification, Space, Card} from "antd";
import moment from "moment";
import {visualizeMonthlyRiskReport} from "../api/api";

export const showMonthlyCustomsReport = async ()=>{
    const {data} = await visualizeMonthlyRiskReport();
    const blobStore = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blobStore);
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
    window.open(url, `monthly_risk_report.pdf`, params);
};

const ReportQuery = ({range:r})=>{

    const [range, setRange] = React.useState(r);

    return <Space>
        <Card title="Monthly risk report" style={{ width: 300 }}>
            <Space direction={"vertical"}>
            <DatePicker.RangePicker defaultValue={range} disabled />
            <Button type={`primary`} style={{width: '100%'}} onClick={()=>{
                showMonthlyCustomsReport();
            }}>View Report</Button>
            </Space>
        </Card>
    </Space>
}

export const RiskManagement  = (props)=>{

    const [opt, setOpt] = React.useState({key: 1, range: [moment().subtract(1, 'month'), moment()]})
   
    return <React.Fragment>
        <ReportQuery range={opt.range} />
    </React.Fragment>
}